import {useState, useEffect, useCallback} from "react"
import * as Requests from "../library/requests/Requests"
import Config from "../library/Config"
import {PresetJson} from "../library/Preset"

interface UseConfigResult {
  config: Config | null
  error: string | null
  loading: boolean
}

export function useConfig(code: string): UseConfigResult {
  const [config, setConfig] = useState<Config | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  const updateConfig = useCallback((preset: PresetJson): void => {
    try {
      window.localStorage.setItem("preset_" + preset.code, JSON.stringify(preset))
    } catch {}

    const newConfig = new Config(preset)
    document.body.style.backgroundColor = newConfig.theme.secondaryBackgroundColor

    const urlParams = new URLSearchParams(document.location.search)
    if (urlParams.get("headshots") === "true") {
      newConfig.headshots.showFaceGuide = true
      newConfig.headshots.showTips = true
    }

    setConfig(newConfig)
    setLoading(false)
  }, [])

  useEffect(() => {
    console.log("environment: ", process.env.NODE_ENV, " is_dev:", process.env.REACT_APP_IS_DEV === "true")

    setLoading(true)
    setError(null)

    const cacheBuster = 4
    try {
      const localPresetString = window.localStorage.getItem("preset_" + code + "_" + cacheBuster)
      if (localPresetString) {
        const cachedPreset = JSON.parse(localPresetString)
        updateConfig(cachedPreset)
      }
    } catch {}

    const presetCode = code.split('-')[0]
    Requests.getPreset(presetCode,
      (fetchedPreset: PresetJson) => {
        updateConfig(fetchedPreset)
      },
      (err: string) => {
        document.body.style.backgroundColor = "none"
        setError(err)
        setLoading(false)
      })
  }, [code, updateConfig])

  return {config, error, loading}
}
